import "./BeautyMenu.module.css";
import Header from "@/reusable_sections/Header";
import ServicesOverview from "./sections/ServicesOverview";
import Services from "./sections/Services";
import PremiumWellness from "./sections/PremiumWellness";
import TherapiesOverview from "./sections/TherapiesOverview";
import CustomerServices from "./sections/CustomerServices";
import Footer from "@/reusable_sections/Footer";
export default function BeautyMenuPage() {
  return <div>
      <Header />
      <ServicesOverview />
      <Services />
      <CustomerServices />
      <PremiumWellness />
      <TherapiesOverview />
      <Footer />
    </div>;
}